import React from 'react';
import { isFeatureEnabled } from 'ff/common/ffAppUtils';

import Fade from '@mui/material/Fade';

import { useDebriefApp, useChrono, useRouteContext } from 'ff/debrief/hooks';
import DebriefMapControls from 'ff/debrief/components/map/DebriefMapControls';
import ErrorBar from 'ff/debrief/components/ErrorBar';
import Timeline from 'ff/debrief/components/timeline';
import DebriefSidebar from 'ff/debrief/components/debriefSidebar/DebriefSidebar';
import Instruments from 'ff/debrief/components/instruments';
import SegmentDetails from 'ff/debrief/components/scoringDetails/SegmentDetails';
import ProcessingStatusToast from 'ff/debrief/components/details/ProcessingStatusToast';
import VspeedAlert from 'ff/debrief/components/VspeedAlert';
import OwnshipMapLayer from 'ff/debrief/components/map/OwnshipMapLayer';
import MapAreaGrid from 'ff/debrief/layouts/MapAreaGrid';
import { LinkToDebrief, LinkToShared } from 'ff/debrief/router';
import Hud from 'ff/debrief/components/hud/Hud';

export const pathString = '/:shareId?/debrief/shared';

const SharedDebriefRoute = () => {
    const { isChartOpen } = useDebriefApp();
    const { currentPoint } = useChrono();

    useRouteContext({
        returnLink: LinkToShared,
        debriefLink: LinkToDebrief,
        page: 'SharedDebriefView',
    });

    return (
        <>
            {currentPoint && (
                <OwnshipMapLayer
                    latitude={currentPoint?.latitude}
                    longitude={currentPoint?.longitude}
                    bearing={currentPoint?.bearing}
                />
            )}
            <MapAreaGrid>
                <VspeedAlert />
                <DebriefMapControls />
                <DebriefSidebar />
                <Timeline />
                <ErrorBar />
                <Fade in={isChartOpen} unmountOnExit>
                    <SegmentDetails />
                </Fade>
                <ProcessingStatusToast />
                {isFeatureEnabled('debrief_hud') && <Hud />}
                {isFeatureEnabled('debrief_features') && <Instruments />}
            </MapAreaGrid>
        </>
    );
};

export default SharedDebriefRoute;
